
  Vue.component('highlights-icon', {
    props: {
      show: { type: Boolean, default: false },
    },
    data() {
      return {
      }
    },
    template: '#highlights-icon',
    computed: {
    },
    watch: {},
    methods: {
    },
    mounted() {}
  })
